import { cn } from '@workspace/ui/lib/utils';

import { company } from '~/company/Company';
import { PriceText } from '~/components/Price/PriceText';
import { formatPriceWithCurrency } from '~/utils/formaters';

import styles from './CDPrice.module.scss';
import type { Props } from './interfaces';

const CDPrice = ({
  classes,
  discount,
  discountPercent,
  price,
  percentDelimiter,
}: Props) => {
  const {
    root: className,
    classNameOldPrice,
    classNameCurrentPrice,
    classNameDiscountPercent,
  } = classes || {};
  const priceText = formatPriceWithCurrency(price);

  return (
    <div className={cn(styles.root, className)}>
      {(discount || discountPercent) && (
        <div
          className={cn(
            styles.discountWr,
            company.match({
              mcosmetic: 'order-1',
            }),
          )}
        >
          {discount && (
            <p className={cn(styles.oldPrice, classNameOldPrice)}>
              <PriceText>{formatPriceWithCurrency(discount)}</PriceText>
            </p>
          )}
          {discountPercent && (
            <span
              className={cn(
                styles.discountPercent,
                percentDelimiter && discount && styles.withDelimiter,
                classNameDiscountPercent,
              )}
            >
              {discountPercent}
            </span>
          )}
        </div>
      )}
      <p
        className={cn(
          styles.currentPrice,
          discount && styles.currentPrice_discounted,
          discount && 'price__discount',
          classNameCurrentPrice,
        )}
      >
        <PriceText>{priceText}</PriceText>
      </p>
    </div>
  );
};

export default CDPrice;
